import { AiOutlineCloseCircle } from "react-icons/ai";
import Modal from "../../common/Modal";
import { FormEvent } from "react";
import { useGlobal } from "../../../context/global";
import { useAlly } from "../../../context/ally";
import AllyService from "../../../services/ally.service";

export default function ConfirmDeleteReservation() {
    const { setIsLoading } = useGlobal()
    const { setSummary, confirmDeleteReservationId, setConfirmDeleteReservationId } = useAlly()
    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            await AllyService.deleteReservation(confirmDeleteReservationId)
            setSummary(prev => prev.filter(item => item.reservation.id !== confirmDeleteReservationId))
            setConfirmDeleteReservationId('')
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <Modal
        onSubmit={onSubmit}
        >
            <h1>Confirm delete reservation</h1>
            <p>Are you sure you want to delete this reservation? This action cannot be undone.</p>
            <button
            style={{backgroundColor: '#e74c3c', color: 'white', marginTop: '20px', padding: '10px 15px', borderRadius: '5px', border: 'none', cursor: 'pointer'}}
            >
                BORRAR
            </button>
            <div className="close"
            onClick={() => setConfirmDeleteReservationId('')}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}